import type { QuestionnaireState } from "../../types";

export const handleRemoveErrorAction = (
  state: QuestionnaireState,
  payload: string, // question name
): QuestionnaireState => {
  const { errors } = state;
  const updatedErrors = { ...errors };
  delete updatedErrors[payload];

  const isValid = Object.keys(updatedErrors).length === 0;

  return {
    ...state,
    errors: updatedErrors,
    isValid,
  };
};
